import { render } from "./khadamat.vue?vue&type=template&id=4339886a"
import script from "./khadamat.vue?vue&type=script&lang=js"
export * from "./khadamat.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/tavakolinejad-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__